import { identityService } from '@afterpaytouch/portal-api/identity'
import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { setCheckoutError } from '../'
import { TerminalErrorCode } from '../../model'

interface IdentityQueryError {
  error: { data: PortalApiError }
}

const setMaxAttemptsCheckoutError = (error: IdentityQueryError, dispatch: ThunkDispatch<any, any, AnyAction>): void => {
  if ([ErrorCode.MaxAttemptsReached, ErrorCode.MaxAttemptsReachedForType].includes(error.error?.data?.errorCode)) {
    dispatch(
      setCheckoutError({
        error: TerminalErrorCode.IdentityDeclined,
        // TODO: CHECKOUT-457: sms verification has already mapped `max_attempts_reached` code. Need to clean up once the A/B test is done

        errorCode: 'Hard_ID_Max_Failures',
      })
    )
  }
}

identityService.enhanceEndpoints({
  endpoints: {
    identityPassport: {
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (e) {
          setMaxAttemptsCheckoutError(e as IdentityQueryError, dispatch)
        }
      },
    },
    identityLicense: {
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (e) {
          setMaxAttemptsCheckoutError(e as IdentityQueryError, dispatch)
        }
      },
    },
    identityMedicare: {
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (e) {
          setMaxAttemptsCheckoutError(e as IdentityQueryError, dispatch)
        }
      },
    },
  },
})

export const {
  useIdentityVerifyMutation,
  useIdentityNationalIDNumberDeprecatedMutation,
  useIdentityPassportMutation,
  useIdentityPassportCountriesQuery,
  useIdentityMedicareMutation,
  useIdentityLicenseMutation,
} = identityService
